import { create } from 'zustand';
import { api } from '../services/api';

interface AuthState {
  authenticated: boolean;
  email: string | null;
  loading: boolean;
  checkSession: () => Promise<void>;
  login: (email: string, password: string, rememberMe?: boolean) => Promise<void>;
  logout: () => Promise<void>;
}

const REMEMBER_EMAIL_KEY = 'waw-auth-email';

export function getRememberedEmail(): string {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(REMEMBER_EMAIL_KEY) || '';
}

export const useAuthStore = create<AuthState>()((set) => ({
  authenticated: false,
  email: null,
  loading: true,

  checkSession: async () => {
    const token = api.getToken();
    if (!token) {
      set({ authenticated: false, email: null, loading: false });
      return;
    }

    try {
      const data = await api.get('/api/auth/session') as { email: string };
      set({ authenticated: true, email: data.email, loading: false });
    } catch {
      api.setToken(null);
      set({ authenticated: false, email: null, loading: false });
    }
  },

  login: async (email: string, password: string, rememberMe = false) => {
    const data = await api.post('/api/auth/login', { email, password, rememberMe }) as { token: string };
    api.setToken(data.token);
    if (typeof window !== 'undefined') {
      if (rememberMe) {
        window.localStorage.setItem(REMEMBER_EMAIL_KEY, email);
      } else {
        window.localStorage.removeItem(REMEMBER_EMAIL_KEY);
      }
    }
    set({ authenticated: true, email, loading: false });
  },

  logout: async () => {
    try {
      await api.post('/api/auth/logout', {});
    } catch {
      // Logout even if the API call fails
    }
    api.setToken(null);
    set({ authenticated: false, email: null });
  },
}));
